(function () {
  if (window.TabioLeeepProductEmbed && window.TabioLeeepProductEmbed.initDragPeekForEmbeddedRoot) {
    return;
  }

  function initDragPeekForEmbeddedRoot(root) {
    try {
      if (!root || root.nodeType !== 1) {
        return;
      }

      let outer = null;
      let viewerType = '';

      outer = root.querySelector('.LeeepListScrollOuter');
      if (outer) {
        viewerType = 'post_list';
      }

      if (!outer) {
        outer = root.querySelector('.LeeepStaffListScrollOuter');
        if (outer) {
          viewerType = 'staff_list';
        }
      }

      if (!outer) {
        outer = root.querySelector('.LeeepBlogList');
        if (outer) {
          viewerType = 'blog_list';
        }
      }

      if (!outer || outer.dataset.__leeepProductEmbedDragPeek) {
        return;
      }
      outer.dataset.__leeepProductEmbedDragPeek = 'true';

      root.classList.add('is-leeep-peek-ready');

      if (viewerType === 'post_list') {
        root.classList.add('is-leeep-post-list');
      } else if (viewerType === 'staff_list') {
        root.classList.add('is-leeep-staff-list');
      } else if (viewerType === 'blog_list') {
        root.classList.add('is-leeep-blog-list');
      }

      outer.classList.add('is-leeep-drag-scroll');

      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let moved = false;

      outer.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      outer.addEventListener('mousedown', function (e) {
        e.preventDefault();
        isDown = true;
        moved = false;
        startX = e.pageX;
        scrollLeft = outer.scrollLeft;
        outer.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDown) {
          return;
        }
        e.preventDefault();

        const walk = (e.pageX - startX) * 1.5;
        if (Math.abs(e.pageX - startX) > 3) {
          moved = true;
        }

        outer.scrollLeft = scrollLeft - walk;
      });

      document.addEventListener('mouseup', function () {
        if (!isDown) {
          return;
        }
        isDown = false;
        outer.style.cursor = 'grab';
      });

      outer.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        },
        true
      );

      outer.style.cursor = 'grab';
    } catch (e) {
      console.warn('[c_leeep-product-embed-drag-peek] ドラッグスクロール初期化に失敗しました', e);
    }
  }

  if (!window.TabioLeeepProductEmbed) {
    window.TabioLeeepProductEmbed = {};
  }
  window.TabioLeeepProductEmbed.initDragPeekForEmbeddedRoot = initDragPeekForEmbeddedRoot;
})();
